import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";
import Fade from "@material-ui/core/Fade";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Divider from "@material-ui/core/Divider";

import "./PopupDrawer.css";

const useStyles = makeStyles({
  topDrawer: {
    padding: 10,
    maxWidth: 340,
    zIndex: 1001
  },
  element: {
    marginBottom: 5
  }
});

const PopupDrawer = ({ popup }) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const popupFocusHandler = () => {
    if (popup) popup.focus();
  };

  const popupCloseHandler = () => {
    if (popup) popup.close();
  };

  const toggleDialogHandler = type => {
    if ((open && type !== "overlay") || (!open && type === "overlay")) {
      if (open && type === "no-button" && popup) popup.focus();
      setOpen(prev => !prev);
    }
  };

  return (
    <>
      <Fade in>
        <div
          className="popup-overlay"
          onClick={() => toggleDialogHandler("overlay")}
          role="presentation"
        />
      </Fade>
      <div className="popup-top-container">
        <Slide direction="down" in={open} mountOnEnter unmountOnExit>
          <Card className={classes.topDrawer}>
            <CardContent>
              <Typography className={classes.element}>
                CANCEL PAYMENT?
              </Typography>
              <Divider className={classes.element} />
              <Typography
                variant="caption"
                component="p"
                color="textSecondary"
                className={classes.element}
              >
                Your payment is ongoing. Are you sure you want to cancel the
                payment?
              </Typography>
            </CardContent>
            <CardActions>
              <Button size="small" onClick={popupCloseHandler}>
                YES, CANCEL
              </Button>
              <Button
                size="small"
                onClick={() => toggleDialogHandler("no-button")}
              >
                NO
              </Button>
            </CardActions>
          </Card>
        </Slide>
      </div>
      <Fade in>
        <div className="bottom-drawer">
          <Typography variant="subtitle1" style={{ marginBottom: 40 }}>
            Your payment is being processed
          </Typography>
          <CircularProgress />
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={popupFocusHandler}
            style={{ marginTop: 40 }}
          >
            Go to payment
          </Button>
        </div>
      </Fade>
    </>
  );
};

PopupDrawer.propTypes = {
  popup: PropTypes.func.isRequired
};

function mapStateToProps({ popupReducer }) {
  return popupReducer;
}

export default connect(mapStateToProps)(PopupDrawer);
